import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import React from 'react';
import { compose, margin, MarginProps } from 'styled-system';

import { Chip, Flex, Icon, Text } from '~/components/blocks';
import { useFetchLineProfile } from '~/components/partials/LineIconTag/use-fetch-line_profile';
import { LineVisitorOfOutpatientQuestionnaireEntryDetailFragment } from '~/graphql/generated/graphql';

type Props = MarginProps & {
  visitor: LineVisitorOfOutpatientQuestionnaireEntryDetailFragment;
};

const CustomChip = styled(Chip, {
  shouldForwardProp,
})<MarginProps>(
  ({ theme }) =>
    css({
      border: theme.borders.default,
      size: 'fixed',
      backgroundColor: theme.colors.colorPallete.white,
      padding: `0 ${theme.space.m}`,
    }),
  () => compose(margin),
);

export const LineIconTag = ({ visitor, ...marginStyles }: Props) => {
  const theme = useTheme();

  const { active } = useFetchLineProfile({ visitor });

  if (!active) return null;

  return (
    <CustomChip {...marginStyles}>
      <Flex alignItems="center">
        <Icon icon="line" size="l" marginRight={theme.space.xs} />
        <Text
          size="xs"
          color={'navy'}
          lineHeight="1"
          padding={`${theme.space.s} 0`}
        >{`友だち`}</Text>
      </Flex>
    </CustomChip>
  );
};
